import React from 'react'
import PropTypes from 'prop-types'

const LineAwesome = ({ icon, className = '' }) => (
  <i className={`la la-${icon} ${className}`} />
)

LineAwesome.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string, // ✅ נוסיף תמיכה בזה
}

export default LineAwesome